import React, { useRef } from 'react';
import { Grid, Typography } from '@mui/material';
import rawGetFormattedPrice from '@shared/helpers/rawGetFormattedPrice';

import PriceInfoIcon from './PriceInfoIcon';
import PriceDetailsSummary from '@shared/pages/Hotels/helpers/PriceDetailsSummary';
import UniversalTooltip from './UniversalTooltip';

const RoomPrice = ({
  compare,
  usdUserTooltip,
  setUsdUserTooltip,
  supplier,
  total_nights,
  total_passangers,
  id_product,
  price,
  title,
  priceAlign = 'center',
  pricePaddingLeft = '0',
  priceColor = '#EC2E20',
  business_types,
  integration,
}) => {
  const priceRef = useRef(null);

  const isB2B = +business_types?.id === 2;
  const amountText = isB2B ? 'Neto total' : 'Precio final';
  const resolvedTitle = title ?? amountText;

  return (
    <>
      <Typography
        sx={{
          fontSize: '18px',
          fontWeight: 600,
          textAlign: 'center',
          color: '#000',
        }}
      >
        {resolvedTitle}
      </Typography>

      <Grid
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: priceAlign,
          alignItems: 'center',
          paddingLeft: pricePaddingLeft,
        }}
      >
        {compare ? (
          <>
            <Typography
              ref={priceRef}
              name="precio"
              style={{
                color: priceColor,
                fontSize: '20px',
                fontWeight: '600',
                textAlign: 'center',
                cursor: 'pointer',
              }}
              onClick={() =>
                setUsdUserTooltip(prev =>
                  prev === id_product + 'user' ? null : id_product + 'user'
                )
              }
              onMouseEnter={() => setUsdUserTooltip(id_product + 'user')}
              onMouseLeave={() => setUsdUserTooltip(null)}
            >
              {rawGetFormattedPrice({
                price,
                business_types,
              })}
            </Typography>

            <UniversalTooltip
              anchorRef={priceRef}
              open={usdUserTooltip === id_product + 'user'}
              onClose={() => setUsdUserTooltip(null)}
              offset={{ x: 10, y: 15 }}
            >
              <PriceDetailsSummary
                ratePrice={price}
                supplier={supplier}
                integration={integration}
                business_types={business_types}
              />
            </UniversalTooltip>
          </>
        ) : (
          <Typography
            name="precio"
            style={{
              color: '#EC2E20',
              fontSize: '20px',
              fontWeight: '600',
              textAlign: 'center',
              position: 'relative',
            }}
          >
            {rawGetFormattedPrice({
              price,
              business_types,
            })}
          </Typography>
        )}

        <PriceInfoIcon
          {...{ price, total_nights, total_passangers, business_types }}
        />
      </Grid>
    </>
  );
};

export default RoomPrice;
